import { render, staticRenderFns } from "./Bands.vue?vue&type=template&id=288bf6b9&scoped=true"
import script from "./Bands.vue?vue&type=script&lang=js"
export * from "./Bands.vue?vue&type=script&lang=js"
import style0 from "./Bands.vue?vue&type=style&index=0&id=288bf6b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288bf6b9",
  null
  
)

export default component.exports